import { BoxProps } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';

type Props = {
  title: string,
  children: React.ReactNode,
} & BoxProps;

const CustomFieldSet: React.FC<Props> = ({ title, children, ...rest }) => {
  return (
    <CC.Box
      as="fieldset"
      border={'1px solid var(--chakra-colors-gray-300)'}
      borderRadius={'5px'}
      p={4}
      maxW={'100%'}
      {...rest}
    >
      <CC.Heading px={title && 2} as="legend" ml={'15px'} fontSize={'md'}>
        {title}
      </CC.Heading>
      {children}
    </CC.Box>
  );
};

export default CustomFieldSet;
